export default __webpack_public_path__ + "5ad779c416aae51ec1b45c7a37697a18.svg";